import { saveAs } from "file-saver";

/*
 *Format Number with Commas
 */
const formatNumber = (num) => {
  return num.toLocaleString();
};

/*
 *Download Image
 */
const downloadImage = (e) => {
  console.log(e);
  saveAs(e, "image.jpg"); // Put your image url here.
};
export { formatNumber,downloadImage };
